// extracted by mini-css-extract-plugin
module.exports = {"tableIcon":"mutipleLocationsCharts_tableIcon__2hdVn","crossIcon":"mutipleLocationsCharts_crossIcon__2ij4R"};